
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaAws } from "react-icons/fa";
import { BsShieldCheck, BsAward, BsCloudCheck } from "react-icons/bs";

const certifications = [
  {
    title: "AWS Certified Solutions Architect",
    issuer: "Amazon Web Services",
    icon: <FaAws />,
  },
  {
    title: "AWS Certified Cloud Practitioner",
    issuer: "Amazon Web Services",
    icon: <BsCloudCheck />,
  },
  {
    title: "CompTIA Security+",
    issuer: "CompTIA",
    icon: <BsShieldCheck />,
  },
  {
    title: "Certified Technical Trainer (CTT+)",
    issuer: "CompTIA",
    icon: <BsAward />,
  },
  {
    title: "Certified in Cybersecurity (CC)",
    issuer: "ISC2",
    icon: <BsShieldCheck />,
  },
];

function Certifications() {
  return (
    <Container className="certifications-section">
      <h1 className="project-heading">
        Professional <strong className="purple">Certifications</strong>
      </h1>

      <p className="certifications-intro">
        Industry-recognized credentials supporting my work in cloud
        computing, cybersecurity, and technical training.
      </p>

      <Row className="justify-content-center">
        {certifications.map((certification) => (
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="certification-column"
            key={certification.title}
          >
            <Card className="certification-card">
              <Card.Body>
                <div className="certification-icon" aria-hidden="true">
                  {certification.icon}
                </div>

                <Card.Title className="certification-title">
                  {certification.title}
                </Card.Title>

                <Card.Text className="certification-issuer">
                  {certification.issuer}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Certifications;
